import { extend } from "vee-validate";
import i18n from "../lang/i18n";
export const emailRegex = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
export const phoneNumberRegex = /^[0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?\s]*$/;

export function validateDateStr(
  dateStr,
  seperator = "-",
  checkBeforeToday = true
) {
  const [year, month, day] = dateStr.split(seperator);

  const yearRegex = /^(19|20)\d\d$/;
  const monthRegex = /^(0[1-9]|1[012])$/;
  const dayRegex = /^(0[1-9]|[12][0-9]|3[01])$/;

  const isLeapYear = year => {
    return (year % 4 == 0 && year % 100 != 0) || year % 400 == 0;
  };

  if (!yearRegex.test(year) || !monthRegex.test(month) || !dayRegex.test(day)) {
    return false;
  }

  if (month === "02") {
    if (!isLeapYear(year) && day === "29") return false;
    if (day === "30" || day === "31") return false;
  }

  if (["04", "06", "09", "11"].includes(month)) {
    if (day === "31") return false;
  }

  if (checkBeforeToday) {
    const givenTime = new Date(`${year}${seperator}${month}${seperator}${day}`);
    const currentTime = new Date();

    if (givenTime > currentTime) {
      return false;
    }
  }

  return true;
}

const _MsgGenerator = {
  required: fieldName =>
    i18n.t("validation.required", { fieldName: fieldName }),
  minLength: (fieldName, minLength) =>
    i18n.t("validation.minLength", {
      fieldName: fieldName,
      minLength: minLength
    }),
  maxLength: (fieldName, maxLength) =>
    i18n.t("validation.maxLength", {
      fieldName: fieldName,
      maxLength: maxLength
    }),
  format: (fieldName, message) =>
    message || i18n.t("validation.format", { fieldName: fieldName })
};

export function generateInvalidMessage(validation, name, value) {
  if (!validation || !(typeof validation === "object")) return "";

  const { required, minLength, maxLength, format } = validation;

  if (required) {
    // String
    if (typeof value === "string" && !(value + "").trim().length)
      return _MsgGenerator.required(name);
    // Array
    if (value instanceof Array && (!value || !value.length))
      return _MsgGenerator.required(name);
    // Object
    if (!value) return _MsgGenerator.required(name);
  }

  if (minLength) {
    if (typeof value === "string" && value.length < minLength)
      return _MsgGenerator.minLength(name, minLength);

    if (value instanceof Array && (!value || value.length < minLength))
      return _MsgGenerator.minLength(name, minLength);
  }

  if (maxLength) {
    if (typeof value === "string" && value.length > maxLength)
      return _MsgGenerator.maxLength(name, maxLength);

    if (value instanceof Array && (!value || value.length > maxLength))
      return _MsgGenerator.maxLength(name, maxLength);
  }

  if (format) {
    if (!format.valid(value)) return _MsgGenerator.format(name, format.message);
  }

  return "";
}

export function registerVeelidateRules() {
  extend("required", {
    validate(value) {
      const isValid = function(value) {
        if (value instanceof Array) {
          return !!value.length;
        }

        return ["", null, undefined].indexOf(value) === -1;
      };

      return {
        required: true,
        valid: isValid(value)
      };
    },
    message: fieldName => _MsgGenerator.required(fieldName),
    computesRequired: true
  });

  extend("minLength", {
    validate(value, { minLength }) {
      return value.length >= minLength;
    },
    params: ["minLength"],
    message: (fieldName, { minLength }) =>
      _MsgGenerator.minLength(fieldName, minLength)
  });

  extend("maxLength", {
    validate(value, { maxLength }) {
      return value.length <= maxLength;
    },
    params: ["maxLength"],
    message: (fieldName, { maxLength }) =>
      _MsgGenerator.maxLength(fieldName, maxLength)
  });

  extend("format", {
    validate(value, { format }) {
      const { valid } = format;
      return valid(value);
    },
    params: ["format"],
    message: (fieldName, placeholders) => {
      const { format } = placeholders;
      return _MsgGenerator.format(fieldName, format.message);
    }
  });
}
